<template>
  <SampleWizard />
</template>

<script>
import SampleWizard from "@/components/samples/SampleWizard";
export default {
  name: "Sample",
  components: { SampleWizard }
};
</script>

<style scoped></style>
